import { AppBar, Box, Toolbar } from '@mui/material';

export default function Layout2({ children }) {
  return (
    <Box sx={{ height: '100vh' }}>
      <AppBar elevation={0} sx={{ bgcolor: 'transparent' }}>
        <Toolbar></Toolbar>
      </AppBar>
      <Box>{children}</Box>
    </Box>
  );
}
